<template>
  <div>
    <v-card class="mb-5 rounded-lg elevation-2">
      <v-card-title class="py-4">
        <v-icon left color="primary" size="30">mdi-tune-variant</v-icon>
        <div>
          <div class="text-h5 font-weight-medium">Cấu hình trạng thái khách hàng</div>
          <div class="text-body-2 grey--text">Quản lý trạng thái, phản hồi và hình thức chăm sóc khách hàng</div>
        </div>
      </v-card-title>
    </v-card>

    <v-card class="rounded-lg elevation-2">
      <v-card-text class="pa-5">
        <div class="text-subtitle-1 font-weight-bold mb-2">1. Nhóm khách hàng</div>
        <v-row class="mb-4">
          <v-col cols="12" md="6">
            <v-card outlined class="pa-3 fill-height">
              <div class="font-weight-bold mb-2"><v-icon left color="blue">mdi-account-plus</v-icon>Khách hàng mới</div>
              <v-chip outlined color="green" class="mr-2"><v-icon left small>mdi-cart-check</v-icon>Khách mua hàng</v-chip>
              <v-chip outlined color="red"><v-icon left small>mdi-cart-remove</v-icon>Khách hủy đơn</v-chip>
            </v-card>
          </v-col>
          <v-col cols="12" md="6">
            <v-card outlined class="pa-3 fill-height">
              <div class="font-weight-bold mb-2"><v-icon left color="indigo">mdi-account-star</v-icon>Khách hàng cũ</div>
              <v-chip outlined color="indigo">Đã mua trên 2 lần</v-chip>
            </v-card>
          </v-col>
        </v-row>
        <v-alert type="info" text dense>Các nhóm khách hàng trên sử dụng chung một bộ cấu hình bên dưới.</v-alert>

        <div class="text-subtitle-1 font-weight-bold mb-2">2. Nội dung cấu hình</div>
        <v-tabs v-model="activeType" color="primary" class="mb-4">
          <v-tab href="#care">Trạng thái chăm sóc</v-tab>
          <v-tab href="#feedback">Trạng thái phản hồi khách hàng</v-tab>
          <v-tab href="#method">Hình thức chăm sóc</v-tab>
        </v-tabs>
        <v-alert type="info" text dense>Trạng thái ngừng dùng vẫn được giữ nguyên trong lịch sử chăm sóc cũ.</v-alert>

        <v-data-table :headers="headers" :items="statuses" :loading="loading" disable-pagination hide-default-footer>
          <template v-slot:item.color="{ item }">
            <v-chip :color="item.color" dark small>{{ item.color }}</v-chip>
          </template>
          <template v-slot:item.is_active="{ item }">
            <v-chip :color="item.is_active ? 'green' : 'grey'" dark small>{{ item.is_active ? 'Đang dùng' : 'Ngừng dùng' }}</v-chip>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-btn icon color="primary" @click="edit(item)"><v-icon>mdi-pencil</v-icon></v-btn>
            <v-btn v-if="item.is_active" icon color="error" @click="disable(item)"><v-icon>mdi-eye-off</v-icon></v-btn>
            <v-btn v-else icon color="success" @click="activate(item)"><v-icon>mdi-eye</v-icon></v-btn>
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-actions class="px-5 pb-5">
        <v-btn color="primary" class="text-none" @click="openCreate"><v-icon left>mdi-plus</v-icon>Thêm trạng thái</v-btn>
      </v-card-actions>
    </v-card>

    <v-dialog v-model="dialog" max-width="480" persistent>
      <v-card>
        <v-card-title>{{ form.id ? 'Sửa' : 'Thêm' }} {{ currentTypeLabel.toLowerCase() }}</v-card-title>
        <v-card-text>
          <v-text-field v-model.trim="form.name" outlined label="Tên trạng thái" :rules="[v => !!v || 'Vui lòng nhập tên trạng thái']" />
          <v-select v-model="form.color" :items="colors" outlined label="Màu hiển thị">
            <template v-slot:selection="{ item }"><v-chip :color="item" dark small>{{ item }}</v-chip></template>
            <template v-slot:item="{ item }"><v-chip :color="item" dark small>{{ item }}</v-chip></template>
          </v-select>
        </v-card-text>
        <v-card-actions><v-spacer /><v-btn text @click="dialog = false">Hủy</v-btn><v-btn color="primary" :loading="saving" :disabled="!form.name" @click="save">Lưu</v-btn></v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import customerModule from '@/api/customers'
const customerActions = customerModule.actions

export default {
  name: 'CustomerCareStatuses',
  data: () => ({
    statuses: [], activeType: 'care', loading: false, saving: false, dialog: false,
    form: { id: null, name: '', color: 'primary' },
    colors: ['primary', 'blue', 'cyan darken-2', 'teal', 'green', 'amber darken-2', 'deep-orange', 'red', 'purple', 'grey darken-1'],
    headers: [
      { text: 'Tên trạng thái', value: 'name' }, { text: 'Màu', value: 'color', width: '180px' },
      { text: 'Tình trạng', value: 'is_active', width: '150px' }, { text: '', value: 'actions', sortable: false, width: '120px', align: 'right' }
    ]
  }),
  watch: { activeType() { this.fetchStatuses() } },
  computed: {
    currentTypeLabel() {
      if (this.activeType === 'feedback') return 'Trạng thái phản hồi'
      if (this.activeType === 'method') return 'Hình thức chăm sóc'
      return 'Trạng thái chăm sóc'
    }
  },
  mounted() { this.fetchStatuses() },
  methods: {
    async fetchStatuses() {
      this.loading = true
      try { const response = await customerActions.getCareStatuses(this.activeType); this.statuses = response.data?.data || [] }
      catch (error) { this.$snackbar.error('Không thể tải trạng thái chăm sóc') }
      finally { this.loading = false }
    },
    openCreate() { this.form = { id: null, name: '', color: 'primary' }; this.dialog = true },
    edit(item) { this.form = { ...item }; this.dialog = true },
    async save() {
      this.saving = true
      try {
        if (this.form.id) await customerActions.updateCareStatus(this.form)
        else await customerActions.createCareStatus({ ...this.form, type: this.activeType })
        this.$snackbar.success('Đã lưu trạng thái chăm sóc'); this.dialog = false; await this.fetchStatuses()
      } catch (error) { this.$snackbar.error(error.response?.data?.message || 'Không thể lưu trạng thái') }
      finally { this.saving = false }
    },
    async disable(item) { await this.setActive(item, false) },
    async activate(item) { await this.setActive(item, true) },
    async setActive(item, isActive) {
      try { await customerActions.updateCareStatus({ ...item, is_active: isActive }); await this.fetchStatuses() }
      catch (error) { this.$snackbar.error(error.response?.data?.message || 'Không thể cập nhật trạng thái') }
    }
  }
}
</script>
